import React from 'react';
import { Card, CardBody, Row, Col } from 'react-bootstrap';
import uploadIcon from "../../Asset/Images/upload-img-icon.svg";
import placeholderPicture from "../../Asset/Images/placeholder-vehicle.png";
import crossIcon from "../../Asset/Images/cross-icon.svg";
import { ToastContainer, toast } from "react-toastify";

// Max allowed file size: 10 MB
const MAX_FILE_SIZE = 10 * 1024 * 1024;

function Attachments({
  vehicleFrontRef,
  vehicleBackRef,
  vehicleSide1Ref,
  vehicleSide2Ref,
  handleVehicleFileChange,
  handleDivClick,
  vehicleFrontPreview,
  vehicleBackPreview,
  vehicleside1Preview,
  vehicleside2Preview,
  vehicleFrontName,
  vehicleBackName,
  handleVehiclePreview,
  handleVehicleRemove,        // ← NEW prop (callback to clear)
  templateId,
}) {

  // Helper: validates file size; returns true if valid
  const validateFileSize = (input) => {
    const file = input?.files?.[0];
    if (file && file.size > MAX_FILE_SIZE) {
      toast.error("File size must not exceed 10 MB.");
      input.value = ""; // reset so the same file can be re-selected
      return false;
    }
    return true;
  };

  // Helper: reset input value before re-opening file picker so same file can be reselected
  const handleChangeClick = (ref, changeKey) => {
    if (templateId) return;
    if (ref && ref.current) {
      ref.current.value = "";
      ref.current.click();
    }
  };

  // Helper: handles removing an uploaded vehicle image
  const handleRemoveClick = (changeKey) => {
    if (templateId) return;
    if (typeof handleVehicleRemove === "function") {
      handleVehicleRemove(changeKey);
    }
    // Also reset the hidden file input so the same file can be picked again
    const refMap = {
      vehicleFrontRef,
      vehicleBackRef,
      vehicleSide1Ref,
      vehicleSide2Ref,
    };
    const ref = refMap[changeKey];
    if (ref && ref.current) {
      ref.current.value = "";
    }
  };

  // Helper: renders one vehicle attachment block
  const renderVehicleBlock = ({
    title,
    refName,
    preview,
    fileName,
    altText,
    changeKey,
  }) => {
    const hasImage = !!preview;

    return (
      <div className="vehicle-mtr-wap">
        <h3 className="vehicle-mt-head">{title}</h3>
        <div className="card-vehicle-wtr">
          <div className="imageHoldercCard-wrapper">
            <div
              className="imageHoldercCard"
              onClick={() => !templateId && !hasImage && handleDivClick(refName)}
              style={{ cursor: !templateId && !hasImage ? "pointer" : "default" }}
            >
              <img
                className="thumb-img-cls"
                src={preview || placeholderPicture}
                alt={altText}
              />

              {/* Upload icon only when no image and not in template/view mode */}
              {!templateId && !hasImage && (
                <span className="icon-upload-wt">
                  <img src={uploadIcon} alt="Upload" />
                </span>
              )}
            </div>

            {/* Cross (X) button — only when image is uploaded and not in view mode */}
            {hasImage && !templateId && (
              <button
                type="button"
                className="vehicle-remove-img-btn"
                onClick={() => handleRemoveClick(changeKey)}
                title="Remove image"
                aria-label="Remove image"
              >
                <img src={crossIcon} alt="Remove" />
              </button>
            )}
          </div>

          <div className="right-mttxt-wp">
            <h4 className="vehicle-txt--sml vehicle-file-name-txt">
              {fileName || 'Vehicle.Img'}
            </h4>

            {/* Show Preview / Change actions after image is uploaded */}
            {hasImage && (
              <div className="vehicle-attach-actions d-flex flex-wrap gap-2 mt-2">
                <button
                  type="button"
                  className="btn btn-sm vehicle-action-btn"
                  onClick={() =>
                    handleVehiclePreview && handleVehiclePreview(preview, fileName || title)
                  }
                >
                  Preview
                </button>

                {
                  !templateId ?
                    <button
                      type="button"
                      className="btn btn-sm vehicle-action-btn"
                      onClick={() => handleChangeClick(refName, changeKey)}
                    >
                      Change
                    </button>
                    :
                    null
                }

              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <Card className="card-stage-bg h-100">
      <ToastContainer />
      <CardBody>
        <div className="emial-heading-wt attachment-heading-row">
          <h3 className="heading-yt-wp">Attachments</h3>
          <span className="attachment-note-txt">
            Attachments can be uploaded in png jpeg, jpg, webp, gif formats only
          </span>
        </div>

        <div className="emial-heading-wt" style={{ cursor: "pointer" }}>
          {!templateId && (
            <>
              <input
                ref={vehicleFrontRef}
                type="file"
                accept="image/png, image/jpeg, image/jpg, image/webp, image/gif"
                style={{ display: "none" }}
                onChange={(e) => {
                  if (!validateFileSize(e.target)) return;
                  handleVehicleFileChange(e.target, "vehicleFrontRef");
                }}
              />
              <input
                ref={vehicleBackRef}
                type="file"
                accept="image/png, image/jpeg, image/jpg, image/webp, image/gif"
                style={{ display: "none" }}
                onChange={(e) => {
                  if (!validateFileSize(e.target)) return;
                  handleVehicleFileChange(e.target, "vehicleBackRef");
                }}
              />
              {/* Vehicle Side 1 & 2 inputs are not required — commented out
              <input
                ref={vehicleSide1Ref}
                type="file"
                accept="image/png, image/jpeg, image/jpg, image/webp, image/gif"
                style={{ display: "none" }}
                onChange={(e) => {
                  if (!validateFileSize(e.target)) return;
                  handleVehicleFileChange(e.target, "vehicleSide1Ref");
                }}
              />
              <input
                ref={vehicleSide2Ref}
                type="file"
                accept="image/png, image/jpeg, image/jpg, image/webp, image/gif"
                style={{ display: "none" }}
                onChange={(e) => {
                  if (!validateFileSize(e.target)) return;
                  handleVehicleFileChange(e.target, "vehicleSide2Ref");
                }}
              />
              */}
            </>
          )}
        </div>

        <Row>
          <Col xs={12}>
            <div className="multivechule-wp">
              {renderVehicleBlock({
                title: "Vehicle Front",
                refName: vehicleFrontRef,
                preview: vehicleFrontPreview,
                fileName: vehicleFrontName,
                altText: "Vehicle front",
                changeKey: "vehicleFrontRef",
              })}

              {renderVehicleBlock({
                title: "Vehicle Back",
                refName: vehicleBackRef,
                preview: vehicleBackPreview,
                fileName: vehicleBackName,
                altText: "Vehicle back",
                changeKey: "vehicleBackRef",
              })}

              {/* Vehicle Side 1 & 2 are not required — commented out

              {renderVehicleBlock({
                title: "Vehicle Side 1",
                refName: vehicleSide1Ref,
                preview: vehicleside1Preview,
                fileName: null,
                altText: "Vehicle side 1",
                changeKey: "vehicleSide1Ref",
              })}

              {renderVehicleBlock({
                title: "Vehicle Side 2",
                refName: vehicleSide2Ref,
                preview: vehicleside2Preview,
                fileName: null,
                altText: "Vehicle side 2",
                changeKey: "vehicleSide2Ref",
              })}
              */}
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
}

export default Attachments;